import * as React from 'react';
import * as _ from 'lodash';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/types';
import { SectionWrapper } from 'common/baseComponents';
import { ContentGMBContainer, Title, ContentGMBContainerSection, Subtitle, GMBContainer, ViewLabel, MainGMBContainer, ListContainer } from './styles';
import { BoxContainer, SidesPadding } from './styles';
import { serviceLoading } from 'common/loaderReducer';
import Loader from 'components/Loader';
import { SeparatorW2 } from 'features/Dealers/DealerConfiguration/styles';
import { FieldSection } from 'features/Dealers/Listings/GMBPreview/FieldSection';
import { getDealerEnginePreview } from 'features/Dealers/Listings/GMBPreview/state/actions';
import { GET_DEALER_ENGINE_PREVIEW_API_REQUEST } from 'features/Dealers/Listings/GMBPreview/state/actionTypes';
import ImageHeader from 'features/Dealers/Listings/GMBPreview/ImageHeader';
import { parseStringDateToDate } from 'features/Dealers/Listings/GMBPreview/state/utils';

const GMBPreview = () => {
    const dispatch = useDispatch();

    const {
        preview,
        isLoading,
        selectedListingId
    } = useSelector((rootState: RootState) => {
        return {
            preview: rootState.dealers.listing.currentListing.enginePreview.gmbPreview,
            selectedListingId: rootState.dealers.listing.listings.selectedListingId,
            isLoading: serviceLoading(rootState, [GET_DEALER_ENGINE_PREVIEW_API_REQUEST]),
        }
    }, shallowEqual);

    React.useEffect(() => {
        if (selectedListingId && selectedListingId != "") {
            dispatch(getDealerEnginePreview("GMB", selectedListingId))
        }
    }, [selectedListingId])

    if (isLoading || !selectedListingId || selectedListingId == "") {
        return <Loader />
    }

    if (preview) {
        return (
            <MainGMBContainer>

                <GMBContainer>

                    <Title>
                        Currently in Google Business Profile
                     </Title>
                    <BoxContainer>
                    <ContentGMBContainer>
                        <ImageHeader />
                        <ContentGMBContainerSection>
                            <SidesPadding>
                            <Subtitle>
                                {
                                    preview.name
                                }
                            </Subtitle>

                            <FieldSection>
                                <ListContainer>
                                    {
                                        preview.categories.map(c => {
                                            return (
                                                <ViewLabel key={c.id}>
                                                    {
                                                        c.name
                                                    }
                                                </ViewLabel>
                                            )
                                        })
                                    }
                                </ListContainer>

                            </FieldSection>
                            </SidesPadding>

                            <SeparatorW2 />

                            <SidesPadding>
                            <FieldSection>
                                {
                                    preview.address
                                }
                            </FieldSection>

                            <FieldSection title="Service Area">
                                <ListContainer>
                                    {
                                        preview.serviceAreas?.map(c => {
                                            return (
                                                <ViewLabel key={c.id}>
                                                    {
                                                        c.name
                                                    }
                                                </ViewLabel>
                                            )
                                        })
                                    }
                                </ListContainer>
                            </FieldSection>

                            <FieldSection title="Phone">
                                {
                                    preview.phone
                                }
                            </FieldSection>

                            <FieldSection >
                                <ListContainer>
                                    {
                                        preview.hoursOfOperation.map(hop => {
                                            return (
                                                <SectionWrapper key={hop.day} justifyContent={"space-between"}>
                                                    <ViewLabel>
                                                        {
                                                            _.capitalize(hop.day)
                                                        }
                                                    </ViewLabel>
                                                    <ViewLabel>
                                                        {
                                                            hop.hours
                                                        }
                                                    </ViewLabel>
                                                </SectionWrapper>

                                            )
                                        })
                                    }
                                </ListContainer>
                            </FieldSection>

                            <FieldSection title="Website">
                                {
                                    preview.website
                                }
                            </FieldSection>

                            <FieldSection title="Appointment URL">
                                {
                                    preview.appointmentURL
                                }
                            </FieldSection>

                            <FieldSection title="Menu URL">
                                {
                                    preview.menuURL
                                }
                            </FieldSection>

                            <FieldSection title="Place an Order Link">
                                {
                                    preview.orderLink
                                }
                            </FieldSection>

                            <FieldSection title="Services">
                                <ListContainer>
                                    {
                                        preview.services.map(s => {
                                            return (
                                                <ViewLabel key={s.id}>
                                                    {
                                                        s.name
                                                    }
                                                </ViewLabel>
                                            )
                                        })
                                    }
                                </ListContainer>
                            </FieldSection>

                            <FieldSection title="Description">
                                {
                                    preview.description
                                }
                            </FieldSection>

                            <FieldSection title="Date Opened">
                                {
                                    parseStringDateToDate(preview.dateOpened)
                                }
                            </FieldSection>
                            </SidesPadding>

                        </ContentGMBContainerSection>
                    </ContentGMBContainer>
                    </BoxContainer>
                </GMBContainer>
            </MainGMBContainer>
        )
    }
    return (<div />)

}


export default GMBPreview